module.exports = __webpack_public_path__ + "img/右3logo.dc1adbb8.png";